import { EnumAttachmentErrorCode } from '../enums/attachment-error-code.enum';

const MESSAGES: Partial<Record<EnumAttachmentErrorCode, string>> = {
  [EnumAttachmentErrorCode.DOCUMENT_CORRUPT]: 'O arquivo parece estar corrompido.',
  [EnumAttachmentErrorCode.PAGE_LIMIT_EXCEEDED]:
    'O arquivo excede o número de páginas permitido.',
  [EnumAttachmentErrorCode.MULTIFRAME_UNSUPPORTED]:
    'Imagens animadas ou com múltiplos quadros não são aceitas.'
};

const FALLBACK = 'Não foi possível anexar o arquivo. Tente novamente.';

interface IAttachmentErrorPayload {
  error?: { error?: { code?: string; message?: string }; code?: string; message?: string };
}

/**
 * O texto do backend tem precedência: ele conhece o limite exato que foi violado.
 * O mapa local cobre o que chega só como código, e o assíncrono do parser, que
 * vem em `error_code` no GET e não traz mensagem.
 */
export const attachmentErrorMessage = (
  code: EnumAttachmentErrorCode | string | null | undefined,
  message?: string | null
): string =>
  message?.trim() || MESSAGES[code as EnumAttachmentErrorCode] || FALLBACK;

const envelopeOf = (error: IAttachmentErrorPayload) =>
  error?.error?.error ?? error?.error;

export const attachmentErrorFromResponse = (error: IAttachmentErrorPayload): string => {
  const envelope = envelopeOf(error);
  return attachmentErrorMessage(envelope?.code, envelope?.message);
};

/** Repetir só resolve o que é transitório; formato e tamanho pedem outro arquivo. */
const CODIGOS_DEFINITIVOS: ReadonlyArray<string> = [
  EnumAttachmentErrorCode.TOO_LARGE,
  EnumAttachmentErrorCode.INPUT_TOO_LARGE,
  EnumAttachmentErrorCode.CONTEXT_TOO_LARGE,
  EnumAttachmentErrorCode.TYPE_UNSUPPORTED,
  EnumAttachmentErrorCode.VALIDATION_ERROR,
  EnumAttachmentErrorCode.DOCUMENT_CORRUPT,
  EnumAttachmentErrorCode.PAGE_LIMIT_EXCEEDED,
  EnumAttachmentErrorCode.MULTIFRAME_UNSUPPORTED
];

const STATUS_DEFINITIVOS: ReadonlyArray<number> = [400, 409, 413, 415, 422];

export const isAttachmentErrorRetryable = (
  error: IAttachmentErrorPayload & { status?: number }
): boolean => {
  const codigo = envelopeOf(error)?.code;
  if (codigo && CODIGOS_DEFINITIVOS.includes(codigo)) {
    return false;
  }
  return !STATUS_DEFINITIVOS.includes(error?.status ?? 0);
};
